<template>
    <div
        :style="{
            ...messageColors,
            //backgroundColor: determineColor(message),
            ...(extendedStyle || {}),
        }"
        :class="{}"
        class="sc-message--text deleted"
    >
        <template>
            <div :style="{ background: messageColors.backgroundColor }" class="sc-message--toolbox">
                <button v-if="me && message.id != null && message.id != undefined" @click="$emit('remove')">
                    <icon-base :color="messageColors.color" icon-name="remove" width="10">
                        <icon-cross />
                    </icon-base>
                </button>
                <slot :me="me" :message="message" name="text-message-toolbox"></slot>
            </div>
        </template>
        <slot :me="me" :message="message" :messageColors="messageColors" :messageText="messageText">
            <div :class="{ 'translatable-content-wrapper': isTranslatable() }">
                <div :class="{ 'after-translate-top': isTranslatable() }" style="display: flex; flex-direction: column">
                    <span
                        class="sc-message--text-content m-1 ml-3 mr-3"
                        style="word-break: break-word; word-break: break-word"
                    >
                        <i class="material-icons">info</i>
                        {{ messageText }}
                    </span>
                </div>

                <div
                    :class="{ 'after-translate-bottom': !!translate && isTranslateOpen && !me }"
                    style="
                        display: flex;
                        flex-direction: row;
                        justify-content: end;
                        align-items: center;
                        padding: 0 0.3rem;
                    "
                >
                    <span
                        v-if="message.data.meta"
                        :style="{ color: messageColors.color }"
                        class="sc-message-meta-new"
                        >{{ metaShorter(message.data.meta) }}</span
                    >
                    <span v-if="message.data.meta2" :style="{ color: messageColors.color }" class="sc-message--meta2">{{
                        message.data.meta2
                    }}</span>
                </div>
            </div>
        </slot>
    </div>
</template>

<script>
import IconBase from "./../components/IconBase.vue";
import IconEdit from "./../components/icons/IconEdit.vue";
import IconCross from "./../components/icons/IconCross.vue";
import SupsisText from "../../common/SupsisText.vue";
import store from "./../store/";
import { log2 } from "../../../utils/log2";
import { mapState } from "vuex";
import TranslatedText from "../TranslatedText";
import _ from "lodash";
import QuoteMessage from "../QuoteMessage.vue";

const log = log2("TextMessage");

export default {
    data() {
        return {
            store,
            colors: ["#1BC5BD", "#725c31", "#3699FF", "#f64e60", "#bb71ff", "#FF7CC8", "#F4E151", "#7994C7", "#BA9292"],
            translating: false,
            translateOff: true,
        };
    },
    props: {
        isChatWindow: { type: Boolean, default: false },
        message: {
            type: Object,
            required: true,
        },
        extendedStyle: {
            type: Object,
        },
        messageColors: {
            type: Object,
            required: true,
        },
        isColored: {
            type: Boolean,
            default: false,
            required: false,
        },
        replyMode: {
            type: Boolean,
            default: false,
        },
        disableTranslation: {
            type: Boolean,
            default: false,
            required: false,
        },
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
            user: (state) => state.auth.user,
            userName: (state) => (state.auth.user ? state.auth.user.name : ""),
            myLang: (state) => _.get(state.auth.user, "lang", "tr"),
            language: (state) => state.language.language,
            autoTranslate: (state) => state.chat.autoTranslate,
            settings: (state) => state.setting.settings,
        }),
        isTranslateOpen() {
            if (!this.settings.autoTranslate) return false;
            return (
                (!this.disableTranslation && !this.isChatWindow) ||
                !!this.autoTranslate.includes(this.message.raw.conversation || this.message.raw.conversationId)
            );
        },
        messageText() {
            return `This message has been deleted by owner`;
        },
        me() {
            return this.message.position === "right";
        },
        translate() {
            if (this.message.raw.translates && this.message.raw.translates.length > 0) {
                this.translateOff = false;
                return this.message.raw.translates.find((x) => x.to === this.myLang);
            } else {
                this.translateOff = true;
                return false;
            }
        },
    },
    methods: {
        determineColor(message) {
            const name = message.author;
            const isRight = this.message.position === "right";
            let color = ";";
            if (isRight && this.isColored && this.userName !== name) {
                let hash = this.hashCode(name);
                let index = hash % this.colors.length;
                color = this.colors[index];
            } else if (this.isColored && this.userName === name) {
                color = "#4e8cff";
            } else if (!this.isColored && !isRight) {
                color = "#EAEAEA";
            } else {
                color = "";
            }

            return color;
        },
        isTranslatable() {
            return false;
        },

        metaShorter(text) {
            let delimiter = " - ";
            let t = text.split(delimiter);
            if (t[0].length > 11) t[0] = t[0].slice(0, 11) + "..";
            return t.join(delimiter);
        },
    },
    mounted() {},
    components: {
        QuoteMessage,
        TranslatedText,
        IconBase,
        IconCross,
        IconEdit,
        SupsisText,
    },
};
</script>

<style lang="scss">
.sc-message--text {
    .sc-message--content.sent,
    .sc-message--text {
        color: white;
        background-color: #4e8cff;
        max-width: calc(100% - 120px);
        word-wrap: break-word;
        font: 15px / 20px Helvetica, Arial, sans-serif;
    }

    &.deleted {
        color: var(--color-text-critical-default);
        background-color: var(--color-bg-critical-low-default);

        .sc-message--text-content {
            display: flex;
            align-items: center;
            gap: 5px;
        }
    }

    .sc-message-meta-new {
        font-size: 8px;
        font-weight: 300;
        color: white;
        text-align: right;
        border-radius: 6px;
        text-transform: uppercase;
        white-space: nowrap;
        text-overflow: ellipsis;
        line-height: 0px !important;
        margin: 5px !important;
        margin-right: 14px !important;
        margin-bottom: 14px !important;
    }

    p {
        a {
            color: inherit !important;
        }
    }
}
</style>
